import { array, object, string } from 'yup'
import { endDateSchema, startDateSchema } from './userSchema'

export const secheduleSchema = object({
  end_date: endDateSchema
    .test('is-valid-date', 'End date must be a valid date', value => !isNaN(Date.parse(value)))
    .test('is-after-start-date', 'End date must be after start date', function (value) {
      const { start_date } = this.parent
      return start_date && value ? Date.parse(value) > Date.parse(start_date) : false
    }),
  staff: array().of(string().required()).min(1, 'Select at least one staff').required('Staff is required'),
  start_date: startDateSchema.test(
    'is-valid-date',
    'Start date must be a valid date',
    value => !isNaN(Date.parse(value))
  )
})
